import React from 'react'
import './index.css'
import request from '@/utils/request'
import { Input, Icon, Button, Form, DatePicker, Checkbox,message } from 'antd'
const FormItem = Form.Item
const { RangePicker } = DatePicker
class Instructions extends React.Component {
  state = {
    TimeNumber: 10,
    fn: null,
    isAgree:false,
    dataObjContent:null
  }
  componentWillMount() {
    this.getDates()
    this.getDataInfo()
  }

  getDates = () => {
    var a = 10
    var Interval = setInterval(() => {
      if (a > 0) {
        a = a - 1
        this.setState({
          TimeNumber: a
        })
      } else {
        clearInterval(Interval)
      }
    }, 1000)
    this.setState({
      fn: Interval
    })
  }
  componentWillUnmount() {
    clearInterval(this.state.fn)
  }
  GetPerson() {
    if (this.state.isAgree == true) {
    this.props.history.push('/Main/Home/PersonAppointment')
    }else{
      message.error('请先勾选同意条款按钮！')
    }
  }
  CheckChange = e => {
    // console.log(e)
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      isAgree:e.target.checked
    })
  }
  getDataInfo(){
    var that = this
    request
    .get('/v1/news?code=2')
    .then(res => {
       console.log('res')
      // console.log(res)
      // console.log(this.state.TimeArray)
      const data = res
      // for (var i = 0; i < this.state.IndexKey; i++) {
      //   ArrayData.unshift({})
      // }
      // console.log(ArrayData)
      console.log(data)
      this.setState({
        dataObjContent: data
      })
    })
  }
  render() {
    const { TimeNumber ,isAgree,dataObjContent} = this.state
    return (
      <div className="instructions">
        <div className="instructions_name">用户协议及隐私条款</div>
        {/* <div className="instructions_title">
          <span className="instructions_title_line"></span>
          <span className="instructions_title_text">开闭馆时间</span>
        </div> */}

        <div className="instructions_content_row" dangerouslySetInnerHTML={{__html:dataObjContent}}>
        </div>
        {/* <div className="instructions_title">
          <span className="instructions_title_line"></span>
          <span className="instructions_title_text">预约须知</span>
        </div>
        <div className="instructions_content">
          <div className="instructions_content_row">
            <span className="text">
              1、通过四川科技馆网站或微信公众号进行参观预约。一人一券，儿童也需预约，凭券入馆，参观券当日一次有效。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              2、按照预约时间携带【本人身份证】，到四川科技馆票务大厅自助取票机凭【本人身份证】免费换参观券入馆。没有身份证的儿童请查看【取票小贴士】。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              3、文明参观，严禁携带易燃易爆物品、有毒有害物品、管制刀具、食品、有安全隐患玩具（滑板车、轮滑车、轮滑等）及宠物入馆，馆内严禁明火、吸烟、用餐。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              4、1.4米以下儿童需成人陪同入馆参观，不可单独入馆。一位成人最多可携带两位1.4米以下儿童（均需要预约参观券）入馆参观,高龄老人及行动不便者须在亲友的陪同下入馆参观。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              5、
              预约成功后，如无法参观，请取消订单。超过2次（含2次）未取消订单者，将无法参观预约。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              6、每日零点系统会自动放出七日后当天的预约名额，请公众提前预约。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              7、如需中途离馆就餐，请在出口处自助人像采集，从入口专用通道返馆即可。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              8、请公众根据预约情况，合理安排出行。科技馆实行网上预约参观，现场没有免费券领取。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              9、因市中心交通拥堵且科技馆停车位有限，特别提倡广大科友们乘坐公共交通来馆，避免因进馆停车难给您带来不便，谢谢支持！
            </span>
          </div>
        </div>
        <div className="instructions_title">
          <span className="instructions_title_line"></span>
          <span className="instructions_title_text">取票小贴士</span>
        </div>
        <div className="instructions_content">
          <div className="instructions_content_row">
            <span className="text">
              1、官网预约取票方式：凭预约人身份证原件到票务服务自助取票机或人工服务取票。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              2、微信预约取票方式：凭预约人身份证原件到票务服务自助取票机或人工服务取票。
            </span>
          </div>
          <div className="instructions_content_row">
            <span className="text">
              3、微信预约备用取票方式：点击微信公众号→门票预约→订单管理→查看详情→凭二维码到票务服务自助取票机扫码取票。（没有身份证的儿童可使用此方法取票）
            </span>
          </div>
        </div>
        <div className="instructions_title">
          <span className="instructions_title_line"></span>
          <span className="instructions_title_text">联系我们</span>
        </div>
        <div className="instructions_content">
          <div className="instructions_content_row">
            <span className="text">四川科技馆网址：http://www.scstm.com</span>
          </div>
          <div className="instructions_content_row">
            <span className="text">咨询电话：028-86609999</span>
          </div>
          <div className="instructions_content_row">
            <span className="text">微信公众号：四川科技馆</span>
          </div>
        </div> */}

        <div className="instructions_footer">
          <div className="instructions_footer_agree">
            <Checkbox onChange={this.CheckChange} checked={isAgree}>同意条款</Checkbox>
          </div>

          <div
            className="instructions_footer_button"
            onClick={el => this.GetPerson()}
          >
            我已阅读，同意预约
            {/* {TimeNumber > 0 ? (
              <span style={{ marginLeft: '5px' }}>{TimeNumber}s</span>
            ) : null} */}
          </div>
        </div>
      </div>
    )
  }
}
export default Instructions
